import * as React from 'react';
import { Res } from 'core/api';
import { Flex, Format } from 'core/ui';

export default function WeightControl({ kgs, pricePerKgs, total }: { kgs: number; pricePerKgs: number; total: number; }): React.ReactNode {
	return <Flex.Vertical>
		<Flex.Item style={{ backgroundColor: '#000000', display: 'flex', justifyContent: 'center', alignItems: 'center' }} size='60px'>
			<h3 className='m-l-sm m-r-sm' style={{ color: '#FFFFFF' }}>
				{Res.Web.SCREEN_DISPLAY_WEIGHT_CONTROL_LBL()}
			</h3>
		</Flex.Item>
		<Flex.Item className='m-t-lg m-l-xl m-r-xl' size='*'>
			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_WEIGHT_CONTROL_KGS_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asQuantity(kgs)}
			</div>


			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_WEIGHT_CONTROL_PRICE_PER_KG_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(pricePerKgs)}
			</div>


			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_WEIGHT_CONTROL_TOTAL_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(total)}
			</div>

		</Flex.Item>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'> </Flex.Item>
	</Flex.Vertical>;
}
